import { useRouter as useProgressRouter } from '@bprogress/next/app';
import { useRouter } from '@/i18n/routing';
import { canGoBackInApp } from '@/utils/inAppNavigation';

export const useSmartBack = () => {
  // Wrap the locale-aware router with bprogress so programmatic navigation drives
  // the top progress bar the same way a <Link> click does (the provider only
  // auto-shows the bar on intercepted anchor clicks). Without this the fallback
  // push to '/' — a game page opened from an external referrer, where there is no
  // in-app history to go back to — would navigate silently, with no progress bar.
  const router = useProgressRouter({ customRouter: useRouter });

  const goBackSmart = () => {
    // Prefer real history only when there is one of our own pages behind us: this
    // returns to the actual previous page using the client cache (fast) instead of
    // rebuilding the home route. We can't trust `document.referrer` (stale across
    // SPA navigations) or `history.length` alone (counts external entries, so a
    // deep link opened from email/search could send `router.back()` off-site), so
    // we rely on the in-app navigation depth tracked while the app is mounted.
    if (canGoBackInApp() && window.history.length > 1) {
      router.back();
    } else {
      router.push('/');
    }
  };

  return goBackSmart;
};
